import React from 'react'
import { SVGIconProps } from '../types'
const SvgSignalWifiStatusbarConnectedNoInternet426X24Px = ({
  size = 16,
  ...props
}: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M13.538 14.154h1.231v-1.23h-1.23zM8 1.846C3.532 1.846.554 4.283.258 4.505l7.736 9.637.006.012.006-.006 4.302-5.36v-3.25h2.609l.83-1.033c-.3-.222-3.28-2.659-7.747-2.659m5.538 9.846h1.231V6.77h-1.23z"
      />
    </g>
  </svg>
)
export default SvgSignalWifiStatusbarConnectedNoInternet426X24Px
